module.exports = __webpack_public_path__ + "img/Zornotza.a6ff303c.jpg";